import React, { useEffect, useState } from "react";
import Header from "./components/Header.jsx";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Landing from "./pages/Landing.jsx";
import Register from "./pages/Register.jsx";
import Billing from "./pages/Billing.jsx";
import Footer from "./components/Footer.jsx";
import OtpVerification from "./pages/OtpVerification.jsx";
import PaymentMethod from "./pages/PaymentMethod.jsx";
import Login from "./pages/Login.jsx";
import { AuthProvider } from "./components/AuthContext.jsx";
import AnalyticsPage from "./additionalFeatures/Analytics.jsx";
import BranchesPage from "./additionalFeatures/Branches.jsx";
import SocialMediaPage from "./additionalFeatures/SocialMedia.jsx";
import AdvertisementPage from "./additionalFeatures/Advertisement.jsx";
import DesignsPage from "./additionalFeatures/Designs.jsx";
import OrdersPage from "./additionalFeatures/Orders.jsx";
import Price from "./pages/Price.jsx";
import AdditionalUsers from "./addOns/AdditionalUsers.jsx";
import AddonPage from "./components/AddonPage.jsx";
import BillingSuccess from "./pages/BillingSuccess.jsx";
import PaymentTransitions from "./pages/PaymentTransitions.jsx";
import PaymentSucccess from "./pages/PaymentSucccess.jsx";
import MultiLocations from "./addOns/MultiLocation.jsx";
import CustomerRegistration from "./pages/CustomerRegistration.jsx";
import CustomerRegistrationSuccess from "./pages/CustomerRegistrationSuccess.jsx";
import Testing from "./pages/Testing.jsx";
import LogoVoting from "./pages/LogoVoting.jsx";
import MenusPage from "./pages/Menus.jsx";

const ScrollToHashElement = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash && location.hash !== "#")
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
  }, [location]);
  return null;
};

const HEADERLESS_ROUTES = ["/menus", "/merchant-menu"];

const isHeaderlessRoute = (pathname) =>
  HEADERLESS_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );

const SiteHeader = ({ isVerified, setIsVerified }) => {
  const location = useLocation();

  if (isHeaderlessRoute(location.pathname)) {
    return null;
  }

  return <Header isVerified={isVerified} setIsVerified={setIsVerified} />;
};

const App = () => {
  const [isVerified, setIsVerified] = useState(false);

  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <SiteHeader isVerified={isVerified} setIsVerified={setIsVerified} />
        <div data-testid="app-container">
          <ScrollToHashElement />
          <Routes>
            <Route path="/" element={<Landing isVerified={isVerified} />} />
            {/* <Route path="/" element={<LogoVoting />} /> */}
            <Route path="/register" element={<Register />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/paymentMethod" element={<PaymentMethod />} />
            <Route path="/login" element={<Login />} />
            <Route path="/price" element={<Price />} />
            <Route path="/billingSuccess" element={<BillingSuccess />} />
            <Route path="/paymentSuccess" element={<PaymentSucccess />} />
            <Route
              path="/paymentTransitions"
              element={<PaymentTransitions />}
            />
            <Route
              path="/addOns/AdditionalUsers"
              element={<AdditionalUsers />}
            />
            {/* Addon Routes using reusable AddonPage component */}
            <Route
              path="/addOns/PermissionSettings"
              element={<AddonPage addonTypeId={2} />}
            />
            <Route path="/addOns/MultiLocations" element={<MultiLocations />} />
            <Route
              path="/addOns/SearchOptimization"
              element={<AddonPage addonTypeId={4} />}
            />
            <Route
              path="/addOns/StampsLoyalty"
              element={<AddonPage addonTypeId={5} />}
            />
            <Route
              path="/addOns/PointsLoyalty"
              element={<AddonPage addonTypeId={6} />}
            />
            <Route
              path="/addOns/CustomizedDesignStamps"
              element={<AddonPage addonTypeId={7} />}
            />
            <Route
              path="/addOns/GiftCard"
              element={<AddonPage addonTypeId={8} />}
            />
            <Route
              path="/addOns/CustomizedDesignGift"
              element={<AddonPage addonTypeId={9} />}
            />
            <Route
              path="/addOns/SocialMediaA"
              element={<AddonPage addonTypeId={10} />}
            />
            <Route
              path="/addOns/SocialMediaB"
              element={<AddonPage addonTypeId={11} />}
            />
            <Route
              path="/addOns/SocialMediaC"
              element={<AddonPage addonTypeId={12} />}
            />
            <Route
              path="/addOns/OrderManagement"
              element={<AddonPage addonTypeId={13} />}
            />
            <Route
              path="/addOns/Reservations"
              element={<AddonPage addonTypeId={14} />}
            />
            <Route
              path="/addOns/CustomerManagement"
              element={<AddonPage addonTypeId={15} />}
            />
            <Route
              path="/addOns/AnalyticalDashboard"
              element={<AddonPage addonTypeId={16} />}
            />
            <Route
              path="/addOns/InteractiveAdvertisement"
              element={<AddonPage addonTypeId={17} />}
            />
            <Route
              path="/addOns/CustomizedMenuQR"
              element={<AddonPage addonTypeId={18} />}
            />
            <Route
              path="/otp-verification"
              element={<OtpVerification setIsVerified={setIsVerified} />}
            />
            <Route
              path="/additionalFeatures/SocialMedia"
              element={<SocialMediaPage />}
            />
            <Route path="/additionalFeatures/Orders" element={<OrdersPage />} />
            <Route
              path="/additionalFeatures/Advertisement"
              element={<AdvertisementPage />}
            />
            <Route
              path="/additionalFeatures/Analytics"
              element={<AnalyticsPage />}
            />
            <Route
              path="/additionalFeatures/Branches"
              element={<BranchesPage />}
            />
            <Route
              path="/additionalFeatures/Designs"
              element={<DesignsPage />}
            />
            <Route path="/customer" element={<CustomerRegistration />} />
            <Route
              path="/customerRegistrationSuccess"
              element={<CustomerRegistrationSuccess />}
            />
            <Route path="/testing" element={<Testing />} />
            <Route path="/logoVoting" element={<LogoVoting />} />
            <Route path="/menus" element={<MenusPage />} />
            <Route path="/menus/:id" element={<MenusPage />} />
            <Route path="/merchant-menu" element={<MenusPage />} />
            <Route path="/merchant-menu/:id" element={<MenusPage />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </AuthProvider>
  );
};

export default App;
